import React from 'react';
class Button extends React.Component{
    render() {
        if (this.props.number === null) {
            // if the particular number is null then the grid item wil be empty 
            return (
                <div></div>
            )
        }
        else {
            return (
                <button onClick={this.props.click} className={this.props.btn}><div className={this.props.cls}>{ this.props.number}</div></button>
            )
        }
    }
}
export default Button;